import LinkItem from 'components/common/Link';
// import { locations } from '../../../../mockData';
import ROUTES from 'constants/routes';
import { getImageUrl } from 'helpers';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectLocations } from 'store/slices/LocationsSlice';
import { setActiveNavigationIndex, setMobileMenuOpen } from 'store/slices/UI-Slice';

const FeaturesDropdownComponent = ({ onClick }) => {
    const dispatch = useDispatch();

    const locations = useSelector(selectLocations);
    const handleClick = () => {
        if (onClick) {
            onClick();
            dispatch(setMobileMenuOpen(false));
            dispatch(setActiveNavigationIndex(null));
        }
    };
    return (
        <>
            <div className="header-nav__item__dropdown-locations">
                {locations?.slice(0, 10).map((item, index) => (
                    <Link to={`${ROUTES.location}/${item.attributes.slug}`} key={index} onClick={handleClick} className="header-nav__item__dropdown-locations__item">
                        <img src={getImageUrl(item.attributes.flag)} alt="" />
                        <div className="tag-text">{item.attributes.name}</div>
                    </Link>
                ))}
            </div>
            <LinkItem text={'View all locations'} to={ROUTES.location} onClick={handleClick} />
        </>
    );
};

export default FeaturesDropdownComponent;
